import React from 'react'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs'
import logoMain from '../../../global/assets/images/logo/swsca-logo-white.svg'
import logoSVG from '../../../global/assets/images/logo/logo-talpor.svg'
import './styles.css'

export function FooterLinks() {
  return (
    <div className="nav menu">
      <div>
        <Link to="/customer-care/contact-us/">Contact Us</Link>
      </div>
      <div>
        <Link to="/customer-care/return-policy/">Returns</Link>
      </div>
      <div>
        <Link to="/customer-care/privacy-policy/">Privacy Policies</Link>
      </div>
      <div>
        <Link to="/customer-care/terms-of-use/">Terms of Use</Link>
      </div>
      <div>
        <Link to="/customer-care/faqs/">FAQ</Link>
      </div>
      <div>
        <Link to="/customer-care/accessibility-statement/">Accessibility</Link>
      </div>
    </div>
  )
}

function Footer(props) {
  return (
    <footer id="Footer" className="wrapper">
      <div className="menu-networks-holder">
        <div className="iso-logo">
          <Link to="/">
            <img src={logoMain} alt="Stan Winston School Of Character Arts" />
          </Link>
        </div>
        {!props.isMobile && <FooterLinks />}
        <div className="social-networks">
          <a
            aria-label="TikTok Page"
            href="https://www.tiktok.com/@stan_winston_school"
            className="tk-btn"
            target="_blank"
            rel="noreferrer"
            title="Stan Winston School on TikTok"
          >
            <div className="tik-tok-container">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
                <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
              </svg>
            </div>
          </a>
          <a
            aria-label="Facebook Page"
            href="https://www.facebook.com/StanWinstonSchool"
            className="fb-btn"
            target="_blank"
            rel="noreferrer"
            title="Stan Winston School on Facebook"
          >
            <i className="icon-facebook" />
          </a>
          <a
            aria-label="Instagram Profile"
            href="https://www.instagram.com/stanwinstonschool/"
            className="ig-btn"
            target="_blank"
            rel="noreferrer"
            title="Stan Winston School on Instagram"
          >
            <i className="icon-instagram" />
          </a>
          <a
            aria-label="YouTube Profile"
            href="https://www.youtube.com/stanwinstonschool"
            className="yt-btn"
            target="_blank"
            rel="noreferrer"
            title="Stan Winston School on YouTube"
          >
            <i className="icon-youtube" />
          </a>
          <a
            aria-label="Pinterest Profile"
            href="https://www.pinterest.com/stanwinston/"
            className="pt-btn"
            target="_blank"
            rel="noreferrer"
            title="Stan Winston School on Pinterest"
          >
            <i className="icon-pinterest" />
          </a>
        </div>
      </div>
      <hr />
      {props.isMobile && <FooterLinks />}
      <div className="rights">
        <div className="copyright">
          Copyright © {dayjs().year()} Stan Winston School. All rights reserved.
        </div>
        <div className="developed">
          Designed & developed by
          <a className="logo-talpor" href="https://www.talpor.com/" target="_blank" rel="noreferrer">
            <img src={logoSVG} alt="TALPOR solutions" />
          </a>
        </div>
      </div>
    </footer>
  )
}

export default Footer
